<template>
  <StandardResourceService
    v-model="activeTab"
    :tab-list="tabList"
    title="千擎线路同步"
  >
    <ProductUpdateComponent v-if="activeTab === 'productUpdate'" />
    <TaskListComponent v-else-if="activeTab === 'taskList'" />
    <TimingTaskComponent v-else-if="activeTab === 'timingTask'" />
    <BlockingRecordComponent v-else-if="activeTab === 'blockingRecord'" />
  </StandardResourceService>
</template>

<script>
import StandardResourceService from '@/customComponents/standard/StandardResourceService.vue'
import ProductUpdateComponent from './components/ProductUpdateComponent.vue'
import TaskListComponent from './components/TaskListComponent.vue'
import TimingTaskComponent from './components/TimingTaskComponent.vue'
import BlockingRecordComponent from './components/BlockingRecordComponent.vue'

export default {
  name: 'QianqingHome',
  components: {
    StandardResourceService,
    ProductUpdateComponent,
    TaskListComponent,
    TimingTaskComponent,
    BlockingRecordComponent
  },
  data () {
    return {
      activeTab: 'productUpdate',
      tabList: [
        { label: '产品更新', key: 'productUpdate' },
        { label: '同步设置', key: 'taskList' },
        { label: '定时任务', key: 'timingTask' },
        { label: '屏蔽记录', key: 'blockingRecord' }
      ]
    }
  }
}
</script>

<style scoped lang="less">
</style>
